import React, { createRef, useCallback, useEffect, useRef, useState } from "react";
import TestDrive from "./testDriver";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { apiAsia } from "../../utils/api-asia";
import { mobileIs, getQueryStrings } from "../../utils/siteUtils";
import { gtag } from "../../utils"
import { Icon } from "../../elements";
import Swiper from "swiper";

import "./style.scss";
import classNames from "classnames";
const SynthetisTestDriver = props => {
	const { lang, fields, rendering, page } = props
	const { image, imageMobile, title, des, carList, titleSize, desSize } = fields
	const isAR = page?.fields?.rtl?.value;
	const swiperEl = useRef(null);
	const rootNode = useRef(null);
	const swiper = useRef(null);
	const [carTypeList, setCarTypeList] = useState(null);
	const [carType, setCarType] = useState(null);
	const [defaultIndex, setDefaultIndex] = useState(0);
	const [swiperShow, setSwiperShow] = useState(false);
	const [dataValue, setDataValue] = useState([]);

	const isMobile = mobileIs();
	const getCarType = () => {
		let idx = carList.map(item => {
			return item.fields.code.value
		})
		let data = []
		carList.forEach(k => {
			if (idx.indexOf(k.fields.code.value) != -1) {
				data.push(k)
				dataValue.push(k.fields.code.value)
			}
		})
		if (window.location.search.split("?")[1]) {
			let params = window.location.search.split("?")[1].split('&');
			if (params[0].split('=')[0] === 'car') {
				setDefaultIndex(dataValue.indexOf(decodeURIComponent(params[0].split('=')[1])))
			}
		}
		setDataValue(dataValue)
		setCarTypeList(data)
	}
	const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    if (rootNode?.current?.getBoundingClientRect()?.top < pageHeight) {
      gtag('event', 'testdrive_exp', {
        'page_title': props?.page?.name
      });
    }
  }
	const buildSwiper = () => {
		if (swiper.current) {
			swiper.current.destroy(true, true);
		}
		swiper.current = new Swiper(swiperEl.current, {
			slidesPerView: 'auto',
			spaceBetween: 0,
			initialSlide: defaultIndex,
			loopedSlides: 2,
			speed: 1000,
			centeredSlides: true,
			loop: true,
			reverseDirection: false,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			on: {
				slideChangeTransitionEnd: function () {
					setTimeout(v => {
						setSwiperShow(true)
					}, 1000)
					if (swiper.current && carTypeList) {
						setCarType(carTypeList[this.realIndex].fields.code.value)
					}
				},
				resize: function(){
					this.update(); 
				}, 
			}
		});
	};
	useEffect(() => {
		let dom = document.querySelector('.pctestdriver');
		let domM = document.querySelector('.mtestdriver');
		if(dom && domM){
			// gtag('event', 'Navigation_button_click', {
			// 	'button_name': isMobile ? domM.textContent : dom.textContent,
			// 	'component_page': global.location.href
			// });
		}
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		let data = []
		data = carList
		if (data.length < 4) {
			data.push(...data)
		}
		setCarTypeList(data)
		getCarType()
		window.addEventListener("scroll", onScroll);
		return () => {
      window.removeEventListener("scroll", onScroll);
    };
	}, []);
	useEffect(() => {
		setTimeout(v=>{
			buildSwiper();
		})

		var url = window.location.search;
		var strs = []
		if (url.indexOf("?") != -1) {    //判断是否有参数
      var str = url.substr(1); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
      strs = str.split("=");   //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
   }

	 	if(carTypeList && carTypeList.length > 0) {
			carTypeList.map((item, index)  => {
				if(item.fields.code.value === unescape(strs[1])) {
					setTimeout(v=> {
						swiper.current.slideTo(index + 2, 0, false)
					}, 100)
				}
			})
		}
		
		
	}, [carTypeList]);
	let size = titleSize ? titleSize?.fields?.phrase?.value : "default",
		otherSize = desSize ? desSize?.fields?.phrase?.value : "default"

	return (
		<div className="c-synthetis-testDriver grid" ref={rootNode}>
			<div className="c-synthetis-testDriver__banner">
				{isMobile && <img src={imageMobile.value.src} />}
				{!isMobile && <img src={image.value.src} />}
				<div className="grid grid-title">
					<RichText className={classNames("title type-h1", size)} tag="div" field={title} />
				</div>
			</div>
			<RichText className={classNames("c-synthetis-testDriver__carTitle type-h1", otherSize)} tag="div" field={des} />
			<div className="c-synthetis-testDriver__carList swiper mySwiper" ref={swiperEl}>
				<div className={classNames('swiper-wrapper', { show: swiperShow })}>
					{carTypeList && carTypeList.map((item, index) => (
						<div className="swiper-slide" data={index} key={index}>
							<div className="swiper-slide-content">
								{item.fields.image.value.src &&
									<img className="car" src={item.fields.image.value.src} />
								}
								{item.fields.icon.value.src &&
									<img className="icon" src={item.fields.icon.value.src} />
								}
							</div>
						</div>
					))}
				</div>
				<div className="swiper-button-next"></div>
				<div className="swiper-button-prev"></div>
				<div className="check">
					<Icon name="Check" />
				</div>
			</div>
			<div className="c-synthetis-testDriver__driver">
				<TestDrive data={fields.form.fields} rendering={rendering} page={page} lang={lang} carType={carType} />
			</div>
		</div>
	);
};
export default SynthetisTestDriver;
